export const ItemTypes = {
  POINT: 'point',
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/constants/index.js